<template>
  <CfpComponent />
</template>

<script>
import CfpComponent from "@/components/cfp/CfpComponent";

export default {
  name: "CallForPapers",
  props: {},
  components: {
    CfpComponent,
  },
  data: () => ({}),
  computed: {},
  methods: {},
};
</script>
